import { render, staticRenderFns } from "./Test17.vue?vue&type=template&id=1aba9154&"
import script from "./Test17.vue?vue&type=script&lang=js&"
export * from "./Test17.vue?vue&type=script&lang=js&"
import style0 from "./Test17.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports